import {
  UPLOAD_FILE, REMOVE_FILE, API_FAIL, UPLOAD_FILE_REQUEST, UPLOAD_FILE_SUCCESS, UPLOAD_FILE_FAIL,
  UPLOAD_PROFILE_IMG, UPLOAD_PROFILE_IMG_SUCCESS, UPLOAD_PROFILE_IMG_FAIL,
  DELETE_PROFILE_IMG, DELETE_PROFILE_IMG_SUCCESS, DELETE_PROFILE_IMG_FAIL



} from "./actionTypes"

const INIT_STATE = {
  loading: false,
  error: "",

}

 /**
      * Used for handle the response of file's api
      */


const file = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPLOAD_FILE_REQUEST:
      return {
        ...state,
        error: "",
        loading: true,
        user: null
      }
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false
      }
    case UPLOAD_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case REMOVE_FILE:
      return {
        ...state,
        error: "",
      }

    case API_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPLOAD_PROFILE_IMG:
      return {
        ...state,
        error: "",
        loading: true,
        user: null
      }
    case UPLOAD_PROFILE_IMG_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false
      }
    case UPLOAD_PROFILE_IMG_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DELETE_PROFILE_IMG:
      return {
        ...state,
        error: "",
        loading: true,
      }
    case DELETE_PROFILE_IMG_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false
      }
    case DELETE_PROFILE_IMG_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }



    default:
      return state
  }
}

export default file;
